import type { CurationTool, Pivot, RelatedTags } from '@empathyco/playboard-core-domain'
import type {
  PivotableExtraParams,
  RegularFilterConfig,
  RegularFilterSelectedValues,
} from '../../models'
import type { CurationToolDomainService, RelatedTagsDomainService } from '../interfaces'
import { inject, injectable } from 'inversify'
import { TYPES } from '../../config/inversify.types'

@injectable()
export class PlatformRelatedTagsDomainService implements RelatedTagsDomainService {
  public constructor(
    @inject(TYPES.CurationToolDomainService)
    protected curationToolDomainService: CurationToolDomainService<RelatedTags>,
  ) {}

  getEmptyInstance(): RelatedTags {
    return this.curationToolDomainService.getEmptyInstance()
  }

  isValid(instance: RelatedTags, extraParams: PivotableExtraParams): boolean {
    return this.curationToolDomainService.isValid(instance, extraParams)
  }

  isCriteriaValid(
    criteria: CurationTool['criteria'],
    pivotsConfig: Record<string, RegularFilterConfig>,
  ): boolean {
    return this.curationToolDomainService.isCriteriaValid(criteria, pivotsConfig)
  }

  setCriteria(oldCriteria: CurationTool['criteria']): CurationTool['criteria'] {
    return this.curationToolDomainService.setCriteria(oldCriteria)
  }

  arePivotsValid(pivots: Array<Pivot>, pivotsConfig: Record<string, RegularFilterConfig>): boolean {
    return this.curationToolDomainService.arePivotsValid(pivots, pivotsConfig)
  }

  updatePivotValues(
    pivots: Array<Pivot>,
    name: string,
    values: RegularFilterSelectedValues,
  ): Array<Pivot> {
    return this.curationToolDomainService.updatePivotValues(pivots, name, values)
  }

  getPivotsAsRequestParams(criteria: CurationTool['criteria']): Record<string, string> {
    return criteria.pivots.reduce(
      (params, pivot) => ({
        ...params,
        [pivot.name]: pivot.values[0],
      }),
      {},
    )
  }
}
